import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { useClassSubmissions } from 'store/submissions/selectors';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { useCurrentUser } from 'store/users/selectors';

const useCurrentAssignment = (assignmentId) => {
  const allSubmission = useClassSubmissions();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const dispatch = useDispatch();


  useEffect(() => {
    if (currentClass?.id && currentUser?.id && allSubmission?.length === 0) {
      dispatch(handleListClassSubmissions(currentClass?.id));
    }
  }, [currentUser?.id, currentClass?.id]);

  const checkAssignmentHaveSubmission = useMemo(() => {
    const checkSubmission = allSubmission
      .filter((k) => k?.assignment?.id === assignmentId)
      .filter(Boolean);
    return checkSubmission?.length > 0 ? true : false;
  }, [allSubmission, assignmentId]);

  return {
    checkAssignmentHaveSubmission,
  };
};

export default useCurrentAssignment;
